/* Auto-generated, do not edit */
import React from 'react';

interface Props {
  size?: number | string;
  width?: number | string;
  height?: number | string;
  fill?: string;
}

function Avatar_icn_avatar21(props: Props) {
    const { size = 14, width = size, height = size, fill = '' } = props;
    return (
      <svg viewBox="0 0 24 24" fill="#27A2A8" width={ `${ width }px` } height={ `${ height }px` } ><path d="M11 3a8 8 0 1 0 0 16 8 8 0 1 0 0-16Z" opacity=".3"/><path d="M18.3 20.8 16 18.5c-1 .8-2.4 1.4-5 1.5-2.3.1-4.6-.8-6.3-2.5C3 15.8 2 13.4 2 11c0-5 4-9 9-9 4.3 0 8.1 3.1 8.9 7.2l-2 .4C17.3 6.4 14.3 4 11 4c-3.9 0-7 3.1-7 7 0 1.9.8 3.7 2.1 5.1 1.3 1.3 3 2 4.8 1.9 2.7-.1 3.6-.8 4.3-1.6l.7-.8 3.8 3.7-1.4 1.5z"/><path d="m18.303 13.717 1.414-1.414 1.98 1.98-1.414 1.414zM18.16 4.485a3.1 1.9-74.342 1 0 3.659 1.025 3.1 1.9-74.342 1 0-3.66-1.025Z"/><path d="M6 8a1 1.5 0 1 0 0 3 1 1.5 0 1 0 0-3zm3-2a1 1.5 0 1 0 0 3 1 1.5 0 1 0 0-3zm0 9c-1.7 0-3-.7-3-1.5S7.3 12 9 12v3zm2-4h3c0 3.1-1.3 5-3 5v-5zm2.9-7.4c-.5-.2-.9-.3-1.4-.4-.5-.1-1-.2-1.5-.2-1.1 0-2.2.2-3.1.6C8.2 5 9.4 6 10.9 6c.4 0 .7-.1 1.1-.2.1 2.3 1.7 4.2 3.6 4.2 1.2 0 2.2-.7 2.9-1.8-.8-2.1-2.5-3.8-4.6-4.6zM3.3 13c-1.3 5.5 2 9 4.2 9 1.6 0 3.1-1.1 3.6-2.8-3.2.1-6.6-3.6-7.8-6.2z"/><path d="M18 14h-.5c-1.5-.3-2.5-1.5-2.5-3 0-1.7 1.3-3 3-3h.5c1.5.3 2.5 1.5 2.5 3 0 1.7-1.3 3-3 3zm-.2-2h.2c.6 0 1-.4 1-1 0-.5-.3-.9-.8-1H18c-.6 0-1 .4-1 1 0 .5.3.9.8 1z"/></svg>
  );
}

export default Avatar_icn_avatar21;
